import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import styles from './style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useSelector } from 'react-redux';
import {
    GetAllLiveStatuses,
    AddLiveStatusMutation,
    DeleteLiveStatusMutation
} from 'shared/services/live_status_services/LiveStatusServices';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';

const presetColors = [
    '#34495e', // Slate Gray
    '#2ecc71', // Emerald Green
    '#f1c40f', // Sun Yellow
    '#e67e22', // Carrot Orange
    '#e74c3c', // Alizarin Red
    '#9b59b6', // Amethyst Purple
    '#3498db', // Peter River Blue
    '#1abc9c', // Turquoise
    '#ff6b81', // Coral Pink
    '#a8e6cf'  // Mint Green
];

export default function ManageLiveStatus({ show, handleClose }) {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);

    const [statusName, setStatusName] = useState('');
    const [selectedColor, setSelectedColor] = useState(presetColors[0]);

    const { data: statuses, isLoading: isGetLoading } = GetAllLiveStatuses();
    const { mutate: addMutate, isLoading: isAddLoading } = AddLiveStatusMutation();
    const { mutate: deleteMutate, isLoading: isDeleteLoading } = DeleteLiveStatusMutation();

    const handleAdd = () => {
        if (!statusName.trim()) return;
        addMutate({
            name: statusName.trim(),
            color: selectedColor
        }, {
            onSuccess: () => {
                setStatusName('');
            }
        });
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this live status?")) {
            deleteMutate(id);
        }
    };

    const isLoading = isGetLoading || isAddLoading || isDeleteLoading;

    return (
        <Modal show={show} onHide={handleClose} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header className={styles.Header}>
                <Heading heading={'Manage Live Status'} headingStyle={styles.AddLinkHeading} />
            </Modal.Header>
            <Modal.Body className={classNames(`${theme}ModalBackground`, styles.Body)}>
                <div className={classNames(styles.AddLinkContainer)}>
                    
                    <CustomInput
                        label={'Status Name'}
                        type={'text'}
                        placeholder={'e.g. Amazon, TikTok Shop'}
                        value={statusName}
                        onChange={(e) => setStatusName(e.target.value)}
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                    />

                    <div className={styles.ColorPickerContainer}>
                        <span className={styles.ColorLabel}>Select Status Color</span>
                        <div className={styles.ColorGrid}>
                            {presetColors.map((color) => (
                                <div
                                    key={color}
                                    className={classNames(styles.ColorBubble, {
                                        [styles.ActiveBubble]: selectedColor === color
                                    })}
                                    style={{ backgroundColor: color }}
                                    onClick={() => setSelectedColor(color)}
                                />
                            ))}
                            
                            {/* Custom Color Selector */}
                            <input
                                type="color"
                                className={styles.CustomColorInput}
                                value={selectedColor}
                                onChange={(e) => setSelectedColor(e.target.value)}
                                title="Custom Color Picker"
                            />
                        </div>
                    </div>

                    <div className="d-flex justify-content-end mb-3">
                        <CustomButton
                            text={'Add Status'}
                            containerStyle={styles.SubmitBtn}
                            submitHandle={handleAdd}
                        />
                    </div>

                    {/* Existing Live Statuses List */}
                    <div className={styles.StatusListContainer}>
                        <h4 className={styles.ListTitle}>Existing Statuses</h4>
                        <div className={styles.StatusList}>
                            {statuses && statuses.length > 0 ? (
                                statuses.map((item) => (
                                    <div key={item._id} className={styles.StatusItem}>
                                        <span
                                            className={styles.StatusBadge}
                                            style={{ backgroundColor: item.color }}
                                        >
                                            {item.name}
                                        </span>
                                        <button
                                            className={styles.DeleteBtn}
                                            onClick={() => handleDelete(item._id)}
                                            title="Delete Status"
                                        >
                                            🗑️
                                        </button>
                                    </div>
                                ))
                            ) : (
                                <div className="text-muted text-center py-2" style={{ fontSize: '13px' }}>
                                    No custom statuses created yet.
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="d-flex justify-content-end mt-4">
                        <CustomButton
                            text={'Close'}
                            containerStyle={styles.CancelBtn}
                            submitHandle={handleClose}
                        />
                    </div>
                </div>
                {isLoading && <OverlayLoading />}
            </Modal.Body>
        </Modal>
    );
}
